export const { format: formatPrice } = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

// "1 produto", "2 produtos": a cesta conta produtos distintos, não unidades.
export const textoQuantidadeProdutos = (quantidade) =>
  `${quantidade} ${Number(quantidade) === 1 ? "produto" : "produtos"}`;

/**
 * Converte texto para formato slug (URL-friendly)
 * @param {string} text - Texto a ser convertido
 * @returns {string} Texto em formato slug
 */
export const toSlug = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD')                   // Normaliza para decompor acentos
    .replace(/[\u0300-\u036f]/g, '')    // Remove acentos
    .replace(/[^\w\s-]/g, '')           // Remove caracteres especiais
    .replace(/\s+/g, '-')               // Substitui espaços por hífens
    .replace(/--+/g, '-')               // Substitui múltiplos hífens por um
    .replace(/^-+/, '')                 // Remove hífens do início
    .replace(/-+$/, '');                // Remove hífens do final
};

/**
 * Converte um slug de volta para texto legível (sem acentos).
 * Ex.: "produtos-de-beleza" -> "Produtos De Beleza".
 * Usado como fallback de label quando não há descrição amigável disponível.
 * @param {string} slug
 * @returns {string}
 */
export const humanizeSlug = (slug) => {
  if (!slug) return '';

  let text = slug.toString();
  try {
    text = decodeURIComponent(text);
  } catch (e) {
    // mantém o valor original se não for um componente de URI válido
  }

  return text
    .replace(/[-_]+/g, ' ')             // hífens/underscores viram espaços
    .replace(/\s+/g, ' ')              // colapsa espaços
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitaliza cada palavra
};
